<template>
    <div class="EnergyConsumpTrend">
        <div class="EnergyConsumpTrend-body">
            <div class="ec-title">能耗趋势</div>
            <div class="line">
                <LineChartTend :data="lineData" :extend-data="lineExtentData" name="功率变化趋势" ref="lineChart"
                    style="height: 90%" v-if="lineData.time && lineData.time.length > 0" />
                <no-data style="padding-top: 12%;" v-else></no-data>
            </div>
        </div>
    </div>

</template>

<script>
import LineChartTend from "@/components/echarts/LineChartTend"
import NoData from "@/components/NoData";
import { getEnergyTrend } from "@/network/ems-record";

export default {
    name: "EnergyConsumpTrend",
    components: {
        LineChartTend,
        NoData,
    },
    data() {
        return {
            lineData: {
                time: [], // 时间数组
                linkRelativeRatio: [], // 总功率数据
                yearOverYear: [] // IT功率数据
            },
            lineExtentData: { 
                "xAxis": [{ "axisLabel": { "rotate": 45 } }],
                "legend": {
                    "data": ["总功率", "IT功率"]
                }
            },
            timer: null
        }
    },
    created() {
        this.getData();
        // 添加到全局定时器管理
        this.$store.dispatch('addIntervalObj', {'getEnergyTrend:60000': this.getData})
    },
    destroyed() {
        // 组件销毁时清除定时器
        this.$store.dispatch('removeIntervalObj', 'getEnergyTrend')
    },
    methods: {
        getData() {
            getEnergyTrend().then(res => {
                if (res.code === 0 && res.data) {
                    // 处理接口返回的数据
                    this.lineData = {
                        time: res.data.times || [], // 时间点列表
                        linkRelativeRatio: res.data.totalPowers.map(val => 
                            Number(val).toFixed(2)
                        ) || [], // 总功率列表
                        yearOverYear: res.data.itPowers.map(val => 
                            Number(val).toFixed(2)
                        ) || [] // IT功率列表
                    };

                    // 如果数据为空，重置图表
                    if (!this.lineData.time.length) {
                        this.lineData = {
                            time: [],
                            linkRelativeRatio: [],
                            yearOverYear: []
                        };
                    }

                    // 更新图表
                    if (this.$refs.lineChart) {
                        this.$refs.lineChart.getOption();
                    }
                }
            }).catch(err => {
                console.error('获取能耗趋势数据失败:', err);
                // 发生错误时清空数据
                this.lineData = {
                    time: [],
                    linkRelativeRatio: [],
                    yearOverYear: []
                };
            });
        },

        // 格式化时间（如果需要）
        formatTime(timeStr) {
            const date = new Date(timeStr);
            return `${date.getMonth() + 1}-${date.getDate()} ${date.getHours()}:${String(date.getMinutes()).padStart(2, '0')}`;
        }
    }
}
</script>

<style scoped>
.EnergyConsumpTrend {
    width: 100%;
    height: 100%;
}

.EnergyConsumpTrend-body {
    width: 100%;
    height: 100%;
    padding: 5% 3% 5% 10%;
}

.EnergyConsumpTrend-body .ec-title {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    font-size: 1.1rem;
    color: #00E3F6;
    margin-bottom: 2%;
}

.line {
    width: 100%;
    height: 100%;
}
</style>